import StoreAction from "./StoreAction";
import { useLocalObservable } from "mobx-react-lite";
import { myTeam } from "../services/TeamService";
import { onAuthStateChanged, getAuth } from "firebase/auth";

const initialState = {
  teamname: "",
  field: "",
  ideation: "",
  teamdId: "",
  members: [
    { title: "CEO", name: "", img: "", id: "" },
    { title: "CTO", name: "", img: "", id: "" },
    { title: "CMO", name: "", img: "", id: "" },
    { title: "CFO", name: "", img: "", id: "" },
    { title: "CDO", name: "", img: "", id: "" },
  ],
};

const TeamStore = () => {
  const store = useLocalObservable(() => ({
    /*observables*/
    ...initialState,
    ...StoreAction(initialState),
    // updateMembers(newMembers) {
    //   for (let i = 0; i < newMembers.length; i++) {
    //     for (let j = 0; j < this.members[i]; j++)
    //       if (this.members[j].title === newMembers[i].title) {
    //         this.members[j].name = newMembers[i].name;
    //         this.members[j].img = newMembers[i].img;
    //         this.members[j].id = newMembers[i].id;
    //       }
    //   }
    // },
  }));

  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    console.log("team store load");
    if (user) {
      myTeam().then((value) => {
        if (value) {
          store.updateData("teamname", value.teamname);
          store.updateData("teamId", value.id);
          store.updateData("field", value.field);
          store.updateData("ideation", value.ideation);
          store.updateData("members", value.members);
        }
      });
    }
  });
  return store;
};

export default TeamStore;
